"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var _isEqual = require('lodash/isEqual');
var antd_1 = require("antd");
var ColorField_1 = __importDefault(require("../../Symbolizer/Field/ColorField/ColorField"));
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var RadiusField_1 = __importDefault(require("../../Symbolizer/Field/RadiusField/RadiusField"));
var OpacityField_1 = __importDefault(require("../../Symbolizer/Field/OpacityField/OpacityField"));
var WellKnownNameField_1 = require("../Field/WellKnownNameField/WellKnownNameField");
var KindField_1 = __importDefault(require("../Field/KindField/KindField"));
var ImageField_1 = __importDefault(require("../Field/ImageField/ImageField"));
var IconSelector_1 = __importDefault(require("../IconSelector/IconSelector"));
require("./BulkEditModals.css");
var BulkEditModals = /** @class */ (function (_super) {
    __extends(BulkEditModals, _super);
    function BulkEditModals(props) {
        var _this = _super.call(this, props) || this;
        _this.onKindFieldChange = function (kind) {
            _this.setState({
                kind: kind
            });
        };
        _this.state = {
            kind: 'Mark'
        };
        return _this;
    }
    BulkEditModals.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    BulkEditModals.prototype.render = function () {
        var _this = this;
        var rules = [];
        var color = '#000000';
        var size = 5;
        var opacity = 1;
        var symbol = 'Circle';
        var _a = this.props, locale = _a.locale, style = _a.style, selectedRowKeys = _a.selectedRowKeys, iconLibraries = _a.iconLibraries;
        var kind = this.state.kind;
        if (style) {
            rules = style.rules;
            var selectedRules = rules.filter(function (rule, index) {
                return selectedRowKeys.includes(index);
            });
            var firstRule = selectedRules.find(function (rule) { return rule.symbolizers && rule.symbolizers.length > 0; });
            if (firstRule && firstRule.symbolizers && firstRule.symbolizers[0]) {
                var sym = firstRule.symbolizers[0];
                if (sym.color) {
                    color = sym.color;
                }
                if (sym.radius) {
                    size = sym.radius;
                }
                if (sym.opacity) {
                    opacity = sym.opacity;
                }
                if (sym.kind && sym.kind === 'Mark' && sym.wellKnownName) {
                    symbol = sym.wellKnownName;
                }
                if (sym.kind && sym.kind === 'Icon' && sym.image) {
                    symbol = sym.image;
                }
            }
        }
        return (React.createElement("div", { className: "gs-style" },
            React.createElement(antd_1.Modal, { title: locale.colorLabel, visible: this.props.colorModalVisible, wrapClassName: "gs-modal-color", footer: null, onCancel: function () { return _this.props.modalsClosed(); } },
                locale.colorLabel,
                React.createElement(ColorField_1.default, { color: color, onChange: this.props.updateMultiColors })),
            React.createElement(antd_1.Modal, { title: locale.radiusLabel, visible: this.props.sizeModalVisible, wrapClassName: "gs-modal-size", footer: null, onCancel: function () { return _this.props.modalsClosed(); } },
                locale.radiusLabel,
                React.createElement(RadiusField_1.default, { radius: size, onChange: this.props.updateMultiSizes })),
            React.createElement(antd_1.Modal, { title: locale.opacityLabel, visible: this.props.opacityModalVisible, wrapClassName: "gs-modal-opacity", footer: null, onCancel: function () { return _this.props.modalsClosed(); } },
                locale.opacityLabel,
                React.createElement(OpacityField_1.default, { opacity: opacity, onChange: this.props.updateMultiOpacities })),
            React.createElement(antd_1.Modal, { title: locale.symbolLabel, visible: this.props.symbolModalVisible, wrapClassName: "gs-modal-opacity", footer: null, onCancel: function () { return _this.props.modalsClosed(); } },
                React.createElement(KindField_1.default, { symbolizerKinds: ['Mark', 'Icon'], kind: kind, onChange: this.onKindFieldChange }),
                kind === 'Mark' ? (React.createElement(WellKnownNameField_1.WellKnownNameField, { wellKnownName: symbol, onChange: function (val) {
                        _this.props.updateMultiSymbols(val, kind);
                    } })) : (React.createElement("div", null,
                    locale.imageFieldLabel,
                    React.createElement(ImageField_1.default, { value: symbol, onChange: function (val) {
                            _this.props.updateMultiSymbols(val, kind);
                        } }),
                    !iconLibraries ? null : (React.createElement("div", { className: "gs-bulk-edit-modals-icon-selector" },
                        React.createElement(IconSelector_1.default, { iconLibraries: iconLibraries, onIconSelect: function (val) {
                                _this.props.updateMultiSymbols(val, kind);
                            }, selectedIconSrc: symbol }))))))));
    };
    BulkEditModals.componentName = 'BulkEditModals';
    BulkEditModals.defaultProps = {
        style: {
            name: 'My Style',
            rules: []
        },
        colorModalVisible: false,
        sizeModalVisible: false,
        opacityModalVisible: false,
        symbolModalVisible: false,
        locale: en_US_1.default.GsBulkEditModals,
        selectedRowKeys: [],
        modalsClosed: function () { return undefined; }
    };
    return BulkEditModals;
}(React.Component));
exports.BulkEditModals = BulkEditModals;
exports.default = LocaleWrapper_1.localize(BulkEditModals, BulkEditModals.componentName);
//# sourceMappingURL=BulkEditModals.js.map